'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour la vidéothèque
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.videotheque', {
        url: '/videotheque',
        templateUrl: 'app/videotheque/videotheque.html',
        controller: 'VideothequeController'
      });
  }]);
